export default __webpack_public_path__ + "images/H8.ddce479.png";